module.exports = "/assets/data/477b9394348c1ec7886f3bcbcba70afc-BB10.data.json";